const buildMetaTags = ({ description = '', keywords = '', robots = '', title = ''}) => {
  return ([
    {
      name: 'description',
      content: description
    },
    {
      name: 'keywords',
      content: keywords
    },
    {
      name: 'robots',
      content: robots
    },
    {
      property: 'og:title',
      content: title
    },
    {
      property: 'og:type',
      content: 'article'
    },
    {
      property: 'og:description',
      content: description
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      name: 'twitter:description',
      content: description
    },
    {
      name: 'twitter:title',
      content: title
    }
  ]);
};

const getCanonicalLink = (feed) => {
  const {
      type = 'story',
      link = '',
      id,
      owner: {
          affiliatetype,
          baseurl,
          siteprotocol = ''
      } = {},
      seo: {
          pageurl,
          canonicallink,
      } = {}  
  } = feed;

  let href = link;

  if (canonicallink) {
    href = canonicallink;
  } else {
    if (affiliatetype !== 5 && id && baseurl && pageurl) {
      // Handle siteprotocol
      let canonicalizedProtocol = '';
      if (siteprotocol) {
        canonicalizedProtocol = siteprotocol.match(/https/) ? 'https://' : 'http://';
      }
      href = `${canonicalizedProtocol}${baseurl}/${type}/${id}/${pageurl}`;
    }
  }
  
  return href;
};

export { buildMetaTags, getCanonicalLink };



// WEBPACK FOOTER //
// ./app/utils/SeoUtils.js